'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _advisors = require('../../modules/advisors');

var _advisors2 = _interopRequireDefault(_advisors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component - the component to render
 *    the property from "propertyKey" will be set to
 *    either the emptyValue or the value returned from parsing
 *    the advisors json file.
 * [options]:
 *    propertyKey - default "advisors",
 *    emptyValue - default {}
 */
exports.default = function (Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  options = Object.assign({
    propertyKey: 'advisors',
    emptyValue: {}
  }, options);

  var advisorsPromise = null;

  var WithAdvisors = function (_React$PureComponent) {
    _inherits(WithAdvisors, _React$PureComponent);

    function WithAdvisors(props) {
      _classCallCheck(this, WithAdvisors);

      var _this = _possibleConstructorReturn(this, (WithAdvisors.__proto__ || Object.getPrototypeOf(WithAdvisors)).call(this, props));

      _this.state = _defineProperty({}, options.propertyKey, options.emptyValue);
      return _this;
    }

    _createClass(WithAdvisors, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _this2 = this;

        if (advisorsPromise == null) {
          advisorsPromise = (0, _advisors2.default)();
        }
        advisorsPromise.then(function (v) {
          return _this2.setState(_defineProperty({}, options.propertyKey, v));
        });
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, this.state));
      }
    }]);

    return WithAdvisors;
  }(_react2.default.PureComponent);

  WithAdvisors.displayName = (Component.displayName || Component.name) + 'WithAdvisors';

  return WithAdvisors;
};


// WEBPACK FOOTER //
// ./node_modules/@rategravity/frontend/components/with-advisors/index.js